package koala.dom

import koala.modifier.*
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.launch
import kotlinx.html.EM
import kotlinx.html.P
import kotlinx.html.SPAN
import kotlinx.html.STRONG
import kotlinx.html.js.p
import web.html.HTMLParagraphElement
import kotlinx.html.js.em as emTag
import kotlinx.html.js.strong as strongTag
import kotlinx.html.js.span as spanTag

/** [text] as a paragraph. */
fun AppendScope.textBlock(
    text: String = "",
    mod: Modifier? = null,
    block: (P.() -> Unit)? = null
) = p {
    addModifiers(mod)
    +text
    block?.invoke(this)
}.unsafeCast<HTMLParagraphElement>()

/** A paragraph showing each distinct value of [binding], as text from [provideValue]. */
fun <T> ViewScope.textBlock(
    binding: Flow<T>,
    mod: Modifier? = null,
    provideValue: (T) -> String = { it.toString() },
    block: (P.() -> Unit)? = null
): HTMLParagraphElement {
    val element = this@textBlock.textBlock(mod = mod, block = block)
    contentScope.launch {
        binding.distinctUntilChanged().collect {
            element.textContent = provideValue(it)
        }
    }
    return element
}

fun AppendScope.em(
    text: String = "",
    mod: Modifier? = null,
    block: EM.() -> Unit = { }
) = emTag {
    addModifiers(mod)
    +text
    block()
}

fun AppendScope.strong(
    text: String = "",
    mod: Modifier? = null,
    block: STRONG.() -> Unit = { }
) = strongTag {
    addModifiers(mod)
    +text
    block()
}

fun AppendScope.span(
    text: String = "",
    mod: Modifier? = null,
    block: SPAN.() -> Unit = { }
) = spanTag {
    addModifiers(mod)
    +text
    block()
}.asWeb()